import React from 'react';

export const MainPage = () => {
	return (
		<div className='content'>
			<h1>Главная</h1>
			<p>SPA react. Чтобы залогится используйте admin/pass.</p>
		</div>
	);
};
